import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var DonateTree = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.583 35.735 23.903 1.693c-.7-1.697-3.097-1.697-3.796 0L5.427 35.735c-.6 1.397.4 2.895 1.897 2.895h13.782v4.892c0 .499.4.898.899.898s.899-.4.899-.898V38.63h13.781c1.398 0 2.497-1.498 1.898-2.895Zm-1.898 1.098H22.903v-2.496l.1-.1 3.596-3.594c.399-.399.399-.898 0-1.297-.4-.4-.9-.4-1.299 0l-2.396 2.395v-5.79l.1-.1 3.595-3.593c.399-.4.399-.899 0-1.298-.4-.4-.9-.4-1.299 0l-2.396 2.396v-6.29c0-.499-.4-.898-.9-.898-.499 0-.898.4-.898.899v6.289l-2.397-2.396c-.4-.4-.899-.4-1.298 0-.4.4-.4.898 0 1.298l3.595 3.594h.1v5.79l-2.397-2.396c-.4-.4-.899-.4-1.298 0-.4.4-.4.898 0 1.298l3.595 3.594h.1v2.495H7.324c-.2 0-.3-.2-.2-.3l14.68-33.842c.1-.2.3-.2.4 0l14.681 33.943c0 .2-.1.399-.2.399Z"
  }));
});
DonateTree.displayName = 'DonateTree';
DonateTree.defaultProps = {
  'aria-label': 'DonateTree'
};
export default DonateTree;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/DonateTree.js
// module id = 3143
// module chunks = 11